import { TreatmentDesignRevisionLiability } from '../treatment-design-revision-judgement';

/** Filters for the revision-reason management list. Every field is optional. */
export interface ListDesignRevisionReasonsParams {
    readonly treatmentTypeOriginalId?: number | null;
    readonly revisionLiability?: TreatmentDesignRevisionLiability | null;
    readonly isActive?: boolean | null;
    readonly search?: string | null;
    /** With a treatment type selected, also return the reasons that apply to every type. */
    readonly includeAllTypes?: boolean | null;
    /** Return only the reasons that apply to every treatment type. */
    readonly onlyAllTypes?: boolean | null;
}
